import { Icon } from '@iconify/react';
import React from 'react';
import ModalImage from 'react-modal-image';

export default function Portfolio({ url }) {
  return (
    <div className="cs_portfolio h-full w-full shadow-lg cs_style_1 cs_radius_20 overflow-hidden">
      <div className="w-full h-full relative">
        <ModalImage
          small={url}
          large={url}
          alt="Gallery"
          className="absolute top-0 left-0 w-full h-full object-cover"
        />
        <span className="cs_link_hover absolute bottom-4 right-4 z-10">
          <i>
            <Icon icon="fa6-solid:arrows-up-down-left-right" />
          </i>
        </span>
      </div>
    </div>
  );
}
